import { useId } from 'react';

import { unitMapping, type Unit } from '#src/lib/style.ts';

type Props = {
  size?: Unit;
  className?: string;
  colors?: [string, string, string];
};
export const Raffle = ({
  size = 4,
  className,
  colors = ['#FFFFFF', '#FCFF63', '#C26900'],
}: Props) => {
  const id = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9099 1.76802L1.76776 15.9102L5.3033 19.4457C6.27961 18.4694 7.86252 18.4694 8.83883 19.4457C9.81514 20.422 9.81514 22.0049 8.83883 22.9812L12.3744 26.5168L26.5165 12.3746L22.981 8.83909C22.0047 9.8154 20.4217 9.8154 19.4454 8.83909C18.4691 7.86278 18.4691 6.27987 19.4454 5.30355L15.9099 1.76802ZM15.9099 15.9102C16.8862 14.9338 16.8862 13.3509 15.9099 12.3746C14.9336 11.3983 13.3507 11.3983 12.3744 12.3746C11.3981 13.3509 11.3981 14.9338 12.3744 15.9102C13.3507 16.8865 14.9336 16.8865 15.9099 15.9102Z"
        fill={`url(#${id}-gradient)`}
      />
      <defs>
        <linearGradient
          id={`${id}-gradient`}
          x1="16.2073"
          y1="2.0165"
          x2="22.1024"
          y2="24.3205"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="0.352177" stopColor={colors[1]} />
          <stop offset="1" stopColor={colors[2]} />
        </linearGradient>
      </defs>
    </svg>
  );
};
